import Vue from 'vue';
let $http = Vue.prototype.$http;

// 登录
// export const Login = (params) => $http({
//     url:'index/login',
//     method:'post',
//     params
// }).then(res=>{
//     return res.data;
// })

// 登录
export const Login = (params) => $http.post('index/login', params).then(res => {
    return res.data
})


// 手机号是否注册
export const PhoneHasReg = (params) => $http.post('index/hasMobile', params).then(res => {
    return res.data
})

// 手机号是否注册
export const PhoneHasReg2 = (params) => $http.post('index/hasMobile2', params).then(res => {
    return res.data
})


// 获取验证码
export const GetVericationCode = (params) => $http.post('index/sendMobileCode', params).then(res => {
    return res.data
})

// 短信登录
export const NoteLogin = (params) => $http.post('index/sms_login', params).then(res => {
    return res.data
})

// 修改密码
export const UpdatePassword = (params) => $http.post('index/forgetPassword', params).then(res => {
    return res.data
})


// 注册
export const registerLogin = (params) => $http.post('index/v1/Login/register', params).then(res => {
    return res.data
})

// 省市县三级联动
export const getArea = (params) => $http.get('publics/v1/Area/getAll', { params }).then(res => {
    return res.data
})

// 获取单位下拉
export const getOrganization = (params) => $http.get('publics/v1/Organization/getAll', { params }).then(res => {
    return res.data
})

// 获取学段下拉
export const getStage = (params) => $http.get('publics/v1/Stage/getAll', { params }).then(res => {
    return res.data
})

// 获取学科下拉
export const getSubject = (params) => $http.get('publics/v1/Subject/getAll', { params }).then(res => {
    return res.data
})

// 获取年级下拉
export const getGrade = (params) => $http.get('publics/v1/Grade/getAll', { params }).then(res => {
    return res.data
})

// 获取项目下拉
export const getProject = (params) => $http.get('publics/v1/Project/getAll', { params }).then(res => {
    return res.data
})

// 获取验证码
export const getsendMobileRCode = (params) => $http.post('index/sendMobileRCode', params).then(res => {
    return res.data
})
